var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 1.25H10C8.275 1.25 6.875 2.65 6.875 4.375V25.625C6.875 27.35 8.275 28.75 10 28.75H20C21.725 28.75 23.125 27.35 23.125 25.625V4.375C23.125 2.65 21.725 1.25 20 1.25ZM15 27.5C13.9625 27.5 13.125 26.6625 13.125 25.625C13.125 24.5875 13.9625 23.75 15 23.75C16.0375 23.75 16.875 24.5875 16.875 25.625C16.875 26.6625 16.0375 27.5 15 27.5ZM9.375 22.5H20.625V5H9.375V22.5Z",
    fill: "#71AD80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.7af66bf99808407f4ccf2538d195d4b8.svg";
export { ForwardRef as ReactComponent };